<template>
  <div class="nav-wrap">
    <div class="nav-container">
      <img class="nav-logo" src="@/assets/image/logo.png" alt="">
      <div class="nav">
        <div class="nav-item" v-for="menu in menus">
          <a :class="menuId == menu.id? 'a-active' : ''" :href="menu.path">
            {{ menu.name }}
            <!-- 核心改动：文字和箭头放在flex容器内垂直居中 -->
            <span v-if="menu.children" class="arrow-icon">▼</span>
          </a>
          <ul class="submenu" v-if="menu.children">
            <li v-for="child in menu.children"><a :href="child.path">{{ child.name }}</a></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    menuId: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      menus: [
        {
          id: 1,
          name: '首页',
          path: '/'
        },
        {
          id: 2,
          name: '古钱币送评',
          path: '#',
          children: [
            { name: '服务内容', path: '/GuQianBi/FuWuNeiRong' },
            { name: '评级标准', path: '/GuQianBi/PingJiBiaoZhun' },
            { name: '收费标准', path: '/GuQianBi/ShouFeiBiaoZhun' },
            { name: '免责条款', path: '/GuQianBi/MianZeTiaoKuan' },
            { name: '赔付标准', path: '/GuQianBi/PeiFuBiaoZhun' },
          ]
        },
        {
          id: 3,
          name: '机制币送评',
          path: '#',
          children: [
            { name: '服务内容', path: '/JiZhiBi/FuWuNeiRong' },
            { name: '评级标准', path: '/JiZhiBi/PingJiBiaoZhun' },
            { name: '瑕疵代码', path: '/JiZhiBi/XiaCiDaiMa' },
            { name: '收费标准', path: '/JiZhiBi/ShouFeiBiaoZhun' },
            { name: '免责条款', path: '/JiZhiBi/MianZeTiaoKuan' },
            { name: '赔付标准', path: '/JiZhiBi/PeiFuBiaoZhun' },
          ]
        },
        {
          id: 4,
          name: '评级流程',
          path: '/News/PingJiLiuCheng'
        },
        {
          id: 5,
          name: '如何送评',
          path: '/News/RuHeSongPing'
        },
        {
          id: 6,
          name: '公告公示',
          path: '/News/GongGaoGongShi'
        },
        {
          id: 7,
          name: '关于我们',
          path: '/News/GuanYuWoMen'
        },
      ]
    }
  },
  methods: {},
  created() {},
}
</script>
<style lang="less" scoped>
/* 导航容器，使用切出来的导航背景图作为背景 */
.nav-wrap {
  width: 100%;
  height: 106px;
  background-color: #FBFBFB;
  box-shadow: 0 1px 4px #f4f4f4;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  .nav-container{
    width: 1200px;
    padding: 25px 0;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .nav-logo{
      width: 160px;
    }
    .nav{
      display: flex;
      justify-content: flex-end;
      font-size: 18px;
      .nav-item{
        margin-left: 45px;
        position: relative;
        a{
          color: #333;
          /* ✅ 关键：a标签开启flex，文字和箭头垂直居中 */
          display: inline-flex;
          align-items: center;
          gap: 6px; /* 文字和箭头之间间距，可自行调整 */
          text-decoration: none;
        }
        .arrow-icon {
          font-size: 12px;
        }
        .a-active,a:hover{
          color: #856e31;
        }
      }
    }
  }
}
/* 二级下拉菜单 默认隐藏 */
.submenu {
  display: none;
  position: absolute;
  top: 100%;
  left: -5px;
  list-style: none;
  margin: 0;
  padding: 0;
  background: #fff;
  box-shadow: 0 0 5px #eaeaea;
  z-index: 99;
  border-radius: 10px;
}
.submenu li a {
  display: block;
  padding: 12px 24px;
  text-decoration: none;
  color: #333;
  white-space: nowrap;
}
/* hover显示下拉 */
.nav-item:hover .submenu {
  display: block;
}
</style>
